import script from "./CheckPoints.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckPoints.vue?vue&type=script&setup=true&lang=js"

import "./CheckPoints.vue?vue&type=style&index=0&id=1ca6c8c4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ca6c8c4"]])

export default __exports__